module.exports = __webpack_public_path__ + "media/bootstrap-icons/key-fill-6086ff56.svg";